import { Operation } from "@/backend/models/operation";
import { useTreeStore } from "@/frontend/store/TreeStore";
import { ContainerTreeObject } from "@/frontend/types/navigationTypes";
import { I18n } from "@/i18n/I18n";
import { useEffect } from "react";
import { useShallow } from "zustand/react/shallow";
import { OperationRun } from "../operations/OperationRun";
import { RunPlaceholder } from "../RunPlaceholder";

export function ScenarioRun(props: { scenarioNode: ContainerTreeObject }) {
  const { scenarioNode } = props;
  const scenario = scenarioNode.container;
  const operations = useTreeStore(useShallow((state) => state.getStoreOperationsForParent(scenario.id)));
  const procedureLoaded = useTreeStore((state) => state.procedureLoaded);
  const observer = useTreeStore((state) => state.observer);
  const loaded = useTreeStore((state) => state.containerLookup[scenario.id]?.loaded);

  useEffect(() => {
    if (!procedureLoaded) {
      useTreeStore.setState({ procedureLoaded: true });
    }
  }, [procedureLoaded]);

  useEffect(() => {
    const observedItem = document.getElementById(`${scenario.id}`);
    if (observer && observedItem) {
      observer.observe(observedItem as HTMLElement);
    }
    return () => {
      if (observer && observedItem) {
        observer.unobserve(observedItem as HTMLElement);
      }
    };
  }, [observer, scenario.id]);

  if (!loaded) {
     return (
       <div aria-label={I18n.get('scenarioLoading')} id={scenario.id} className="card-header bg-body-secondary">
         <RunPlaceholder />
         {operations.map((operation) => <div id={operation.id} key={operation.id} />)}
       </div>
     );
  }

  return (
        <div id={scenario.id} className="card-header observed-element">
        {operations.map((operation, index) => {
          const builtOperation = new Operation(operation);
          return (
            <div key={operation.id} className='card-body'>
              <OperationRun operation={builtOperation}/>
              {index !== operations.length - 1 && (
                <hr className='mb-1' />
              )}
            </div>
          );
        })}
      </div>
  );
}
